export const keysToDisplayBL = [
  { key: "cod_booking", label: "Booking" },
  { key: "ocean_vessel", label: "Ocean Vessel" },
  { key: "port_descharge", label: "Port Discharge" },
  { key: "port_loading", label: "Port Loading" },
  { key: "from", label: "Origin" },
  { key: "place_delivery", label: "Destination" },
  { key: "dae", label: "DAE" },
  { key: "tipo_bl", label: "Tipo BL" },
  { key: "info_shipper", label: "Info Shipper" },
  { key: "info_consignee", label: "Info Consignee" },
  { key: "info_notify", label: "Info Notify" },
  { key: "forma_pago", label: "Término Flete" },
  { key: "shipper_reference", label: "Shipper Reference" },
];

export const keysToDisplayContainers = [
  { key: "cod_contenedor", label: "Contenedor" },
  { key: "sellos", label: "Sellos" },
  { key: "peso_neto", label: "Peso Neto" },
  { key: "num_bultos", label: "# Bultos" },
  { key: "peso_bruto", label: "Peso Bruto" },
  { key: "measurement", label: "Measurement" },
  { key: "desc_ad_cont", label: "Descripción Adicional" },
  { key: "num_paquetes", label: "# Paquetes" },
  { key: "ref_adicionales", label: "Marcas" },
  { key: "tipo_empaque", label: "Tipo Empaque" },
];
